export const getSouthEasternAustraliaData = () => ({
  name: "South Eastern Australia",
  country: "Australie",
  description: "South Eastern Australia est une zone géographique viticole qui englobe les régions viticoles du sud-est de l'Australie, incluant des parties de la Nouvelle-Galles du Sud, du Victoria et de l'Australie-Méridionale. Cette vaste zone produit une grande variété de vins de qualité, bénéficiant de climats diversifiés et de sols variés.",
  type: "region",
  mapAreas: [
    { region: "South Eastern Australia", x: 145.0, y: -36.0, color: "#4B164C", size: 8 }
  ],
  statistics: {
    totalArea: "45,000 ha",
    production: "6 million hectolitres",
    subregions: "15+ sous-régions",
    grapeVarieties: "20+ cépages",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climats variés : méditerranéen sur la côte, continental à l'intérieur, océanique dans les zones montagneuses",
    soil: "Sols diversifiés : calcaires, argileux, sableux, granitiques, excellente diversité géologique",
    viticulture: "Viticulture moderne et durable, utilisation de technologies avancées, rendements contrôlés"
  },
  wineStyles: {
    red: "Vins rouges équilibrés et fruités, avec des tanins mûrs et une bonne structure",
    white: "Vins blancs frais et aromatiques, avec une belle acidité et des notes florales",
    rosé: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle et Charmat"
  },
  history: "La viticulture dans le sud-est de l'Australie a commencé avec les premiers colons européens au XIXe siècle. La région a bénéficié de l'immigration italienne, allemande et française qui a apporté des techniques viticoles traditionnelles. Aujourd'hui, South Eastern Australia est reconnue pour sa production de vins de qualité et son innovation viticole.",
  foodPairing: "Cuisine australienne moderne : barbecue, fruits de mer, viandes rouges, cuisine fusion. Les vins de South Eastern Australia s'accordent parfaitement avec la gastronomie internationale et les plats épicés.",
  subregions: {
    "riverina": {
      name: "Riverina",
      description: "La Riverina est une région viticole importante du sud-est de l'Australie, connue pour ses vins de qualité et sa production de masse. Située dans le sud-ouest de la Nouvelle-Galles du Sud, elle bénéficie d'un climat chaud et sec.",
      characteristics: {
        climate: "Climat chaud et sec, étés longs et hivers doux",
        soil: "Sols alluviaux fertiles, argileux et calcaires",
        viticulture: "Viticulture irriguée, rendements élevés, mécanisation importante"
      },
      grapeVarieties: {
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"],
        white: ["Chardonnay", "Sauvignon Blanc", "Semillon"]
      },
      wineStyles: {
        red: "Vins rouges fruités et accessibles, avec des tanins mûrs",
        white: "Vins blancs frais et aromatiques, parfaits pour la consommation quotidienne"
      },
      foodPairing: "Cuisine australienne simple : barbecue, plats familiaux, cuisine internationale"
    },
    "murray-darling": {
      name: "Murray Darling",
      description: "La région Murray Darling s'étend le long des rivières Murray et Darling, produisant des vins de qualité dans un climat chaud et sec. Cette région est connue pour ses vins rouges puissants et ses vins blancs aromatiques.",
      characteristics: {
        climate: "Climat continental chaud, étés très chauds, hivers froids",
        soil: "Sols alluviaux, sableux et argileux, bien drainés",
        viticulture: "Viticulture irriguée, taille en gobelet, vendanges mécaniques"
      },
      grapeVarieties: {
        red: ["Shiraz", "Cabernet Sauvignon", "Grenache"],
        white: ["Chardonnay", "Viognier", "Marsanne"]
      },
      wineStyles: {
        red: "Vins rouges puissants et concentrés, avec des notes de fruits mûrs",
        white: "Vins blancs aromatiques et riches, avec une belle texture"
      },
      foodPairing: "Cuisine australienne robuste : viandes rouges, plats épicés, fromages affinés"
    },
    "goulburn-valley": {
      name: "Goulburn Valley",
      description: "La Goulburn Valley est une région viticole historique du Victoria, connue pour ses vins de qualité et ses cépages traditionnels. Cette région produit des vins équilibrés et élégants.",
      characteristics: {
        climate: "Climat continental modéré, étés chauds, hivers froids",
        soil: "Sols alluviaux, argileux et calcaires, bien drainés",
        viticulture: "Viticulture traditionnelle, taille en guyot, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"],
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"]
      },
      wineStyles: {
        red: "Vins rouges équilibrés et élégants, avec des tanins fins",
        white: "Vins blancs frais et minéraux, avec une belle acidité"
      },
      foodPairing: "Cuisine victorienne : plats traditionnels, viandes rôties, poissons grillés"
    }
  }
}); 